import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-container">
      <div className="contact-left">
        <h1>Contacto</h1>
        <p>Contáctanos y te responderemos lo antes posible.</p>
        <form>
          <input type="text" placeholder="Nombre" required />
          <input type="email" placeholder="Email" required />
          <textarea placeholder="Mensaje" rows="5" required></textarea>
          <button type="submit">Enviar</button>
        </form>
      </div>
      <div className="contact-right">
        <h3>Horario</h3>
        <p>Lunes – Viernes: 6:00 – 22:00</p>
        <p>Fines de Semana: Cerrado</p>
        <h3>Dirección</h3>
        <p>Polígono Arbide. Calle A, 2. 31110 Noain (Navarra)</p>
        <h3>Contacto</h3>
        <p>Email: info@centrombz.es</p>
        <p>Teléfono: +34 636 72 07 37</p>
      </div>
    </div>
  );
}

export default Contact;
